export const itemConsistOf = {
  contractPeriod: 1,
  customer: 2,
  seller: 3,
  offer: 4,
  declarations: 5,
};

export const cssColorClass = {
  1: 'success-color',
  2: 'warning-color',
  3: 'warning-color1',
};
export const leftBorderColor = {
  1: 'left-border-color-success',
  2: 'left-border-color-warning',
  3: 'left-border-color-warning1',
};
export const ColorAndBorder = {
  1: 'color-border-success',
  2: 'color-border-warning',
  3: 'color-border-warning1',
};

export const claimCoverCode = {
  1: 'perte',
  75: 'casse',
};

export const refBenefitProvider = {
  SPBS: '1',
  SAVE: '3',
  TELSTORE: '30',
  CORDON: '21',
};

export const providerPrefix = {
  '3': 'SV',
  '30': 'TS',
  '21': 'CRDN',
  '1': 'SPBS',
};

export const deviceDeposite = {
  PSM_POST: '9',
  CORDON_POST: '18',
  TELSTORE_POST: '21',
  RELAY_POINT_PROXIMITY: '12',
  RELAY_POINT_DELIVERY: '13',
};
